import { Card, CardContent, Chip, Typography, Box, Divider } from '@mui/material'
import { Cancel } from '@mui/icons-material'

export function DeclinedInviteTile({ invite }) {
  const clientName = invite.corporateName || `${invite.clientFirstName} ${invite.clientLastName}`

  return (
    <Card
      sx={{
        height: '100%',
        width: 320,
        display: 'flex',
        flexDirection: 'column',
        opacity: 0.75,
      }}
    >
      <CardContent sx={{ flexGrow: 1 }}>
        <Typography variant="h6" component="div" gutterBottom noWrap title={clientName}>
          {clientName}
        </Typography>

        <Typography variant="body2" color="text.secondary" gutterBottom>
          {invite.fundName || `${clientName} Giving Fund`}
        </Typography>

        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mt: 1, mb: 2 }}>
          <Chip label="Declined by Donor" size="small" icon={<Cancel fontSize="small" />} color="default" />
        </Box>

        <Divider sx={{ my: 2 }} />

        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          <Typography variant="body2" color="text.secondary">
            <strong>Email:</strong> {invite.clientEmail}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            <strong>Type:</strong> {invite.fundType === 'corporate' ? 'Corporate' : 'Personal'}
          </Typography>
        </Box>
      </CardContent>
    </Card>
  )
}
